import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-85ac378c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "zhushou-box"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "如有任何疑问，您可扫码添加小助手，快速与我们取得联系！", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createBlock(_component_el_dialog, {
    modelValue: $data.showLoginDialog,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.showLoginDialog = $event),
    top: "15vh",
    width: "500px",
    "before-close": $options.handleClose,
    onClosed: $options.closed
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
      src: $options.zhushouImg,
      alt: ""
    }, null, 8, _hoisted_2), _hoisted_3])]),
    _: 1
  }, 8, ["modelValue", "before-close", "onClosed"]);
}